var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-board"},[_c('photo-grid',{attrs:{"box-height":_vm.boxHeight,"box-width":_vm.boxWidth,"excess-text":'+ {{count}}'},on:{"clickExcess":_vm.triggerClick}},_vm._l((_vm.images),function(item,index){return _c('img',{key:item.url,attrs:{"src":item.url},on:{"click":() => _vm.imageView(index)}})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }